export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.21-1016.33",
  commitId: "10e4ff0662a700adc5227d0945a8c96eda883c5d",
  commitTime: "2026-09-21T10:16:33.000Z",
});
